module.exports = __webpack_public_path__ + "img/banner.3e83b5fa.png";